<template>
    <div class="account-page">
        	<!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					
					<div class="row justify-content-center">
						<div class="col-md-9">
								
							<!-- Register Content -->
							<div class="account-content">
								<div class="row align-items-center justify-content-center">
									<div class="col-md-7 col-lg-6 login-left">
										<img src="@/assets/img/login-banner.png" class="img-fluid" alt="Dreams Library Register">	
									</div>
									<div class="col-md-12 col-lg-6 login-right">
										<div class="login-header">
											<h3>Daftar Sebagai Siswa<router-link to="/instructor/register">Apakah kamu seorang Guru?</router-link></h3>
										</div>
										
										<div class="alert alert-danger" v-if="errors">
											{{ errors }}
										</div>
										<!-- Register Form -->
										<form @submit.prevent="register">
						
											<div class="form-group form-focus">
												<input type="email" class="form-control floating" v-model="email" required>
												<label class="focus-label">Email</label>
											</div>
											<div class="form-group form-focus">
												<input type="text" class="form-control floating" v-model="namaUser" required>
												<label class="focus-label">Nama Sesuai Identitas</label>
											</div>
											<div class="form-group form-focus">
												<input type="tel" class="form-control floating" v-model="noHp"  @input="acceptNumber" required>
												<label class="focus-label">Nomor Ponsel</label>
											</div>
											<div class="form-group form-focus">
												<input type="password" class="form-control floating" v-model="password" required>
												<label class="focus-label">Kata Sandi</label>
											</div>
											<!-- <div class="form-group">
												<div class="terms-accept">
													<div class="custom-checkbox">
													   <input type="checkbox" id="terms_accept">
													   <label for="terms_accept">Saya menyetujui <a href="#">Ketentuan &amp; Kebijakan Privasi</a></label>
													</div>
												</div>
											</div> -->
											<button class="btn btn-primary btn-block btn-lg login-btn" type="submit">Daftar</button>
											
											<div class="text-right">
												<router-link class="forgot-link" to="/login">Sudah punya akun?</router-link>
											</div>
											<!-- <div class="login-or">
												<span class="or-line"></span>
												<span class="span-or">or</span>
											</div> -->
											<!-- <div class="row form-row social-login">
												<div class="col-12">
													<a href="#" class="btn btn-google btn-block"><i class="fab fa-google mr-1"></i> Daftar dengan Google</a>
												</div>
											</div> -->
										</form>
										<!-- /Register Form -->
										
									</div>
								</div>
							</div>
							<!-- /Register Content -->
								
						</div>
					</div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->
	  
    </div>
</template>

<script>
export default {
	name: 'Register',
	data() {
		return {
			email: '',
			namaUser: '',
			noHp: '',
			password: '',
      		errors: null,
			msg:null
		}
	},
	methods: {
		register: function () {
		let data = {
			namaUser: this.namaUser,
			email: this.email,
			noHp: this.noHp,
			password: this.password,
			hakAkses: "1",
			kategori: null,
			namaTempatKerja: null
		};
		
		console.log(data);
		this.$store
			.dispatch("register", data)
			.then(response => {
				// console.log(response)
				if(response.data.status == "error"){
					this.errors = response.data.data;
					let timerInterval
                    swal.fire({
                    title: 'Register',
                    html: response.data.data,
                    timer: 2000,
                    // icon: 'warning',
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
						
                    })
				} else {
					let timerInterval
                    swal.fire({
                    title: 'Register',
                    html: 'Registrasi Berhasil, silahkan login :)',
                    timer: 2000,
                    // icon: 'success',
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
						this.$router.push({
							name: 'login-page'
						})
                    })

					// this.msg = "Registrasi Berhasil :)";
					// this.$router.push({
					// 	name: 'login-page'
					// })
				}
			}).catch(error => {
				this.errors = error.data.data;//.response.data.errors
			})
		},

		acceptNumber() {
			// console.log(this.noHp);
        	var x = this.noHp.replace(/\D/g, '').match(/(\d{0,4})(\d{0,4})(\d{0,5})/);
			this.noHp = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
		}
	}	
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/Register/index.vue